<template>
  <v-row
    no-gutters
    :data-title="method.name"
    align="center"
    class="method py-2 px-3 rounded mb-2 cursor-pointer grey"
    @click="$emit('click', method)"
  >
    <v-icon class="mr-3" :color="selected ? 'primary' : null">
      {{ selected ? '$checkboxOn' : '$checkboxOff' }}
    </v-icon>
    <div class="mr-3 px-1">
      <v-img
        height="40"
        max-width="40"
        contain
        :src="$asset(`img/logos/payments/${method.name}.png`)"
      />
    </div>
    <div class="text-h4 d-flex flex-column">
      {{ method.title }}
      <v-img
        v-if="method.name === 'card'"
        :src="$asset('img/logos/payments/card_additional.png')"
        contain
        max-width="68"
        max-height="16"
      />
    </div>
  </v-row>
</template>

<script>
export default {
  name: 'PaymentMethod',
  props: {
    method: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.method {
  height: 56px;
  transition: background-color 0.2s ease-in-out;

  &:hover,
  &:focus,
  &:active {
    background-color: $grey-lighten !important;
  }
}
</style>
